import React from "react";
import SelectListDropdown from "../../common/select_list_dropdown/main";
import WatermarkSettings from "./watermark_settings";
import WatermarkOverlay from "./watermark_overlay";
import './styles/advanced_video_editor'

export default class AdvancedVideoDownload extends React.Component {
  state = {
    videoTypes: [
      "mp4",
      "ogv",
      "mov",
      "flv",
      "webm",
      "animated gif",
      "png",
      "mp3/audio",
      "waveform png"
    ],
    videoFormats: this.formats,
    showWaterMark: false,
    selectedGridBox: -1,
    watermarkUrl: "",
    watermarkDelay: 0,
    watermarkDuration: "00:00",
    watermarkPublicId: "",
    watermarkPosition: "south_west",
    watermarkScaleFactor: null,
    watermarkHeight: this.defaultWatermarkHeight,
    startTime: 0,
    endTime: this.videoDuration,
    showWaterMark: false,
    videoType: this.videoType,
    videoFormat: "original",
    opacity: 50,
    downloadUrl: this.downloadUrl,
    downloading: false
  };

  componentWillMount() {
    let _this = this;
    setTimeout(function() {
      _this.setState({ endTime: _this.videoDuration });
    }, 500);
  }

  get defaultWatermarkHeight() {
    return this.props.attachment.data.height / 2;
  }

  get formats() {
    let { height } = this.props.attachment;
    if (height >= 1080) {
      return ["480p", "720p", "1080p", "original"];
    } else if (height >= 720) {
      return ["480p", "720p", "original"];
    } else if (height >= 480) {
      return ["480p", "original"];
    } else {
      return ["original"];
    }
  }

  get videoType() {
    return this.props.attachment.mimetype.split("/")[1];
  }

  get videoDuration() {
    return this.props.attachment.data["duration"]
      ? this.formatTime(this.props.attachment.data["duration"])
      : "00:00";
  }

  get downloadUrl() {
    // Force download as content disposition with fl_attachment parameter
    return this.props.attachment.url.replace('upload/', 'upload/fl_attachment/');
  }

  get jpg() {
    let url = this.props.attachment.url;
    return url.substr(0, url.lastIndexOf(".")) + ".jpg";
  }

  get videoHeight() {
    if (this.state.videoFormat === "original") {
      return this.props.attachment.data.height;
    }
    return Number(this.state.videoFormat.split("p")[0]);
  }

  videoUrl(mimetype) {
    let startSeconds = this.getSeconds(this.state.startTime);
    let endSeconds = this.getSeconds(this.state.endTime);
    let url = this.props.attachment.url;

    let urlWithExt = url.substr(0, url.lastIndexOf(".")) + "." + mimetype;
    if (startSeconds > 0 && endSeconds > 0) {
      return urlWithExt + "#t=" + startSeconds + "," + endSeconds;
    } else if (startSeconds > 0 && endSeconds === 0) {
      return urlWithExt + "#t=" + startSeconds;
    } else if (startSeconds == 0 && endSeconds > 0) {
      return urlWithExt + "#t=," + endSeconds;
    } else {
      return urlWithExt;
    }
  }

  getSeconds(time) {
    let seconds;
    let timeSegments = time.toString().indexOf(":") > 0 ? time.split(":") : 0;
    if (timeSegments.length === 3) {
      let hoursInSeconds = Number(timeSegments[0]) * 60 * 60;
      let minutesInSeconds = Number(timeSegments[1]) * 60;
      return hoursInSeconds + minutesInSeconds + Number(timeSegments[2]);
    } else if (timeSegments.length === 2) {
      let minutesInSeconds = Number(timeSegments[0]) * 60;
      return minutesInSeconds + Number(timeSegments[1]);
    } else {
      return Number(time);
    }
  }

  formatTime(s, m) {
    s = Math.floor(s);
    m = Math.floor(s / 60);
    m = m >= 10 ? m : "0" + m;
    s = Math.floor(s % 60);
    s = s >= 10 ? s : "0" + s;
    return m + ":" + s;
  }

  updateFileType(type) {
    this.setState({ videoType: type });
  }

  updateFileFormat(format) {
    this.setState({ videoFormat: format });
  }

  updateWatermark(value, type, version) {
    let updatedValue = null;
    let returnObj = {};
    if (type == "watermarkUrl" && value.length > 0) {
      this.setState({ watermarkPublicId: value });
      updatedValue = `http://videocloud.brandfolder.com/image/upload/v${version}/${value}.png`;
    }
    returnObj[type] = updatedValue ? updatedValue : value;
    this.setState(returnObj);
  }

  clippedDuration() {
    if (this.state.startTime != 0 || this.state.endTime != this.videoDuration) {
      let clippedDuration =
        this.getSeconds(this.state.endTime) -
        this.getSeconds(this.state.startTime);
      return clippedDuration;
    }
    return this.getSeconds(this.videoDuration);
  }

  checkWatermarkDelay() {
    let delay = this.getSeconds(this.state.watermarkDelay);
    if (
      delay > this.getSeconds(this.videoDuration) ||
      delay > this.getSeconds(this.state.endTime) ||
      delay < 0
    ) {
      this.setState({ watermarkDelay: 0 });
      this.setState({ watermarkDuration: this.clippedDuration() });
      Notify.create({
        title: "Delay cannot be longer than video",
        type: "error"
      });
    }
  }

  checkWatermarkDuration() {
    let duration =
      this.getSeconds(this.state.watermarkDelay) +
      this.getSeconds(this.state.watermarkDuration);
    if (duration > this.clippedDuration()) {
      this.setState({
        watermarkDuration: this.formatTime(
          this.clippedDuration() - this.getSeconds(this.state.watermarkDelay)
        )
      });
      Notify.create({
        title:
          "Watermark duration may not surpass video duration or clipped video duration",
        type: "error"
      });
    } else if (this.getSeconds(this.state.watermarkDelay) < 0) {
      this.setState({ watermarkDuration: 0 });
      Notify.create({ title: "Invalid watermark duration", type: "error" });
    }
  }

  defaultWatermarkDuration() {
    let duration =
      this.getSeconds(this.state.watermarkDuration) -
      this.getSeconds(this.state.watermarkDelay);
    let defaultDuration = this.formatTime(this.clippedDuration() - duration);
    this.setState({ watermarkDuration: defaultDuration });
  }

  checkStartTime() {
    let start = this.getSeconds(this.state.startTime);
    if (
      start > this.getSeconds(this.videoDuration) ||
      start > this.getSeconds(this.state.endTime) ||
      start < 0
    ) {
      this.setState({ startTime: 0 });
      Notify.create({ title: "Invalid start time", type: "error" });
    }
    this.reloadVideo();
  }

  checkEndTime() {
    let end = this.getSeconds(this.state.endTime);
    if (
      end > this.getSeconds(this.videoDuration) ||
      end < this.getSeconds(this.state.startTime) ||
      end < 0
    ) {
      this.setState({ endTime: this.videoDuration });
      Notify.create({ title: "Invalid end time", type: "error" });
    }
    this.reloadVideo();
  }

  reloadVideo() {
    document.getElementById("vid").load();
  }

  valueFormattedCorrectly(value) {
    if (value.toString().indexOf(":") > 0) {
      for (var i = 0; i < value.split(":").length; i++) {
        let getSegmentValue = Number(value.split(":")[i]);
        if (isNaN(getSegmentValue)) {
          return false;
        }
      }
    } else if (isNaN(Number(value)) && value != "") {
      return false;
    }
    return true;
  }

  updateStartTime(e) {
    if (this.valueFormattedCorrectly(e.target.value)) {
      this.setState({ startTime: e.target.value });
      this.clippedDuration();
    }
  }

  updateEndTime(e) {
    if (this.valueFormattedCorrectly(e.target.value)) {
      this.setState({ endTime: e.target.value });
      this.clippedDuration();
    }
  }

  handleConversion() {
    let noFileExtension = this.state.downloadUrl.substr(
      0,
      this.state.downloadUrl.lastIndexOf(".")
    );
    if (this.state.videoType === "animated gif") {
      let gifFlags = noFileExtension.replace(
        "upload/",
        "upload/vs_10,dl_500,fl_awebp,fl_animated/"
      );
      return `${gifFlags}.gif`;
    } else if (this.state.videoType === "mp3/audio") {
      return `${noFileExtension}.mp3`;
    } else if (this.state.videoType === "waveform png") {
      let waveformFlags = noFileExtension.replace(
        "upload/",
        "upload/h_300,w_750,fl_waveform,co_black,b_none/"
      );
      return `${waveformFlags}.png`;
    } else {
      return `${noFileExtension}.${this.state.videoType}`;
    }
  }

  handleSizing() {
    let url = this.state.downloadUrl;
    let urlSegments = url.split("upload/");
    let height = Number(this.state.videoFormat.split("p")[0]);
    let quality = `h_${height}/`;
    return `${urlSegments[0]}upload/${quality}${urlSegments[1]}`;
  }

  handleClipping() {
    let url = this.state.downloadUrl;
    let urlSegments = url.split("upload/");
    let startSeconds = this.getSeconds(this.state.startTime);
    let endSeconds = this.getSeconds(this.state.endTime);
    let clipping = `so_${startSeconds},eo_${endSeconds}`;
    clipping += urlSegments[1].indexOf("h_") > -1 ? "," : "/";
    return `${urlSegments[0]}upload/${clipping}${urlSegments[1]}`;
  }

  handleWatermark() {
    let url = this.state.downloadUrl;
    let urlSegments = url.split("upload/");
    let watermarkFolder = this.state.watermarkPublicId.split("/")[0];
    let watermarkId = this.state.watermarkPublicId.split("/")[1];
    let watermarkImage = `l_${watermarkFolder}:${watermarkId}`;
    let watermarkPosition = `g_${this.state.watermarkPosition}`;
    let watermarkOpacity = `o_${this.state.opacity}`;
    let watermarkHeight = `h_${this.state.watermarkHeight}`;
    let watermarkDelay = `so_${this.getSeconds(this.state.watermarkDelay)}`;
    let watermarkDuration = `eo_${this.getSeconds(this.state.watermarkDelay) +
      this.getSeconds(this.state.watermarkDuration)}`;
    let watermark = `${watermarkImage},${watermarkPosition},${watermarkOpacity},${watermarkHeight},${watermarkDelay},${watermarkDuration}/`;
    return `${urlSegments[0]}upload/${watermark}${urlSegments[1]}`;
  }

  createAndShowDownloadUrl(e) {
    e.preventDefault();
    e.stopPropagation();
    let convertedUrl = this.handleConversion();
    this.setState({ downloadUrl: convertedUrl }, function() {
      convertedUrl = this.state.downloadUrl;
      if (this.state.videoFormat != "original") {
        convertedUrl = this.handleSizing();
      }
      this.setState({ downloadUrl: convertedUrl }, function() {
        convertedUrl: this.state.downloadUrl;
        if (
          this.state.startTime != 0 ||
          this.state.endTime != this.videoDuration
        ) {
          convertedUrl = this.handleClipping();
        }
        this.setState({ downloadUrl: convertedUrl }, function() {
          convertedUrl = this.state.downloadUrl;
          if (this.state.watermarkPublicId) {
            convertedUrl = this.handleWatermark();
          }
          this.setState({ downloadUrl: convertedUrl }, function() {
            this.setState({ downloading: true }, function() {
              this.clickDownload();
            });
          });
        });
      });
    });
  }

  clickDownload() {
    document.getElementById("download-url").click();
    Notify.create({ title: "File Downloading", type: "success" });
    setTimeout(
      function() {
        let showLink = $("#" + this.props.asset_key + " .j-asset-name a");
        this.setState({ downloading: false });
        showLink.click();
        // Analytics
        Insight.createEvent("downloaded", this.props.asset_key, "asset");
        // Google Analytics
        BF.fx.dataLayerPush({
          brandfolder: BF.fx.slug(),
          event: "AdvancedVideoComplexDownload"
        });
      }.bind(this),
      1000
    );
  }

  showVideoFormats() {
    if (
      this.state.videoType === "mp3/audio" ||
      this.state.videoType === "waveform png"
    ) {
      return;
    }
    return (
      <SelectListDropdown
        list={this.state.videoFormats}
        defaultValue="original"
        dropdownLabel="RESOLUTION"
        onSelect={this.updateFileFormat.bind(this)}
        scroll={true}
      />
    );
  }

  showWaterMark() {
    if (this.state.showWaterMark) {
      let watermarkHeight =
        this.state.watermarkHeight > this.videoHeight
          ? this.videoHeight / 2
          : this.state.watermarkHeight;
      return (
        <WatermarkOverlay
          src={this.state.watermarkUrl}
          selectedGridBox={this.state.selectedGridBox}
          opacity={this.state.opacity}
          updateWatermark={this.updateWatermark.bind(this)}
          watermarkHeight={watermarkHeight}
          videoHeight={this.videoHeight}
          watermarkScaleFactor={this.state.watermarkScaleFactor}
        />
      );
    }
  }

  showWatermarkSettings() {
    let vT = this.state.videoType;
    if (vT === "mp3/audio" || vT === "waveform png" || vT === "png") {
      return;
    }
    let watermarkHeight =
      this.state.watermarkHeight > this.videoHeight
        ? this.videoHeight / 2
        : this.state.watermarkHeight;
    let videoDuration = this.videoDuration ? this.videoDuration : "00:00";
    return (
      <WatermarkSettings
        watermarkUrl={this.state.watermarkUrl}
        watermarkHeight={watermarkHeight}
        opacity={this.state.opacity}
        updateWatermark={this.updateWatermark.bind(this)}
        selectedGridBox={this.state.selectedGridBox}
        videoDuration={this.videoDuration}
        defaultWatermarkDuration={this.defaultWatermarkDuration.bind(this)}
        watermarkDelay={this.state.watermarkDelay}
        formatTime={this.formatTime}
        videoHeight={this.videoHeight}
        watermarkDuration={this.state.watermarkDuration}
        checkWatermarkDelay={this.checkWatermarkDelay.bind(this)}
        checkWatermarkDuration={this.checkWatermarkDuration.bind(this)}
        clippedDuration={this.clippedDuration()}
      />
    );
  }

  showClipping() {
    if (this.state.videoType != "png") {
      return (
        <div className="full video-clip video-input-wrap">
          <div className="flex-half">
            <div className="video-label full"> Clip Start </div>
            <input
              className="full"
              type="text"
              value={this.state.startTime}
              onChange={this.updateStartTime.bind(this)}
              onBlur={this.checkStartTime.bind(this)}
            />
          </div>
          <div className="flex-half">
            <div className="video-label full"> Clip End </div>
            <input
              className="full"
              type="text"
              value={this.state.endTime}
              onChange={this.updateEndTime.bind(this)}
              onBlur={this.checkEndTime.bind(this)}
            />
          </div>
        </div>
      );
    }
  }

  render() {
    const { attachment } = this.props;
    let buttonStyle = `float-right ${
      this.state.downloading ? "yacht-button-disabled disabled" : "yacht-button"
    }`;
    return (
      <div className='advanced-video-editor-component'>
        <div className="video-modal-wrap full" data-asset={this.props.asset_key}>
          <div className="video-display half">
            <div className="video-overlay">
              {this.showWaterMark()}
              <video
                id="vid"
                width="100%"
                height="auto"
                controls
                poster={this.jpg}
                >
                <source src={this.videoUrl("webm")} type="video/webm" />
                <source src={this.videoUrl("mp4")} type="video/mp4" />
                <source src={this.videoUrl("ogv")} type="video/ogg" />
              </video>
            </div>
          </div>
          <div
            className="download-information half"
            style={{
              background: "rgba(241, 241, 241, 0.82)",
              padding: "20px",
              borderRadius: "4px"
            }}
            >
            <h3
              style={{
                margin: "0px 0px 5px 10px",
                textTransform: "uppercase",
                fontSize: "14px",
                padding: "0px 0px 12px 10px",
                borderBottom: "1px solid black",
                fontWeight: "100"
              }}
              >
              Advanced Video Download Options
            </h3>
            <div
              className="full advanced-video download"
              style={{ paddingLeft: "10px" }}
              >
              <div className="half first-dropdown">
                <SelectListDropdown
                  list={this.state.videoTypes}
                  defaultValue={this.videoType}
                  dropdownLabel="FILE TYPE"
                  onSelect={this.updateFileType.bind(this)}
                  scroll={true}
                  />
              </div>
              <div className="half zero-margin">{this.showVideoFormats()}</div>
              {this.showClipping()}
              {this.showWatermarkSettings()}
              <div
                className="s-download-attachment"
                style={{ marginTop: "15px" }}
                >
                {this.state.downloading ? (
                  <a
                    id="download-url"
                    href={this.state.downloadUrl}
                    download={attachment.filename}
                    />
                ) : (
                  ""
                )}
                <button
                  onClick={this.createAndShowDownloadUrl.bind(this)}
                  className="yacht-button btn float-right"
                  style={{ padding: "10px 50px" }}
                  >
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
